import React from 'react';

import {
  AlertSize,
  AlertVariant,
  Content,
  IconSlot,
  StyledAlert,
} from './styles';

export type AlertProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: AlertVariant;
  size?: AlertSize;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  icon?: React.ReactNode;
};

const Alert = ({
  variant = 'info',
  size = 'md',
  color,
  backgroundColor,
  borderColor,
  icon,
  children,
  ...rest
}: AlertProps): JSX.Element => {
  return (
    <StyledAlert
      role="alert"
      $variant={variant}
      $size={size}
      $color={color}
      $backgroundColor={backgroundColor}
      $borderColor={borderColor}
      {...rest}
    >
      {icon && <IconSlot>{icon}</IconSlot>}
      <Content>{children}</Content>
    </StyledAlert>
  );
};

export default Alert;
